/**
 * File Name          : sensor-color.component.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export enum SENSOR_LED_PATTERN {
  OFF = "sensor-off",
  ON = "sensor-on",
  ERROR = "sensor-error",
  POWER_DOWN = "sensor-power-down",
  RECORDING = "sensor-recording",
  CHARGING = "sensor-charging",
  CHARGED = "sensor-charged",
  LOW_BATTERY = "sensor-low-battery",
  CONNECTED = "sensor-connected",
  DISCONNECTED = "sensor-disconnected"

}

@Component({
  selector: 'app-sensor-color',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sensor-color.component.html',
  styleUrl: './sensor-color.component.scss'
})
export class SensorColorComponent {
  @Input() deviceColor: string = '#FFFFFF';
  @Input() led_pattern: SENSOR_LED_PATTERN = SENSOR_LED_PATTERN.ON;

  @Input() onClickHandler: () => void = () => {};
  @Input() tooltipText: string|undefined = undefined;

  @Input() showNotification: boolean = false;


  clicked = () => {
    this.onClickHandler();
  }

  tooltip = {
    visible: false,
    text: '',
    x: 0,
    y: 0
  };

  showTooltip = (event: MouseEvent) => {
    if(!this.tooltipText) return;
    this.tooltip.visible = true;
    this.tooltip.text = this.tooltipText;
    this.tooltip.x = event.offsetX + 10;
    this.tooltip.y = event.offsetY + 10;
  }

  hideTooltip() {
    this.tooltip.visible = false;
  }
}
  